module.exports = __webpack_public_path__ + "static/media/IMG_4950.7dad7730.jpg";